/**
 * Utility functions for mobile device detection
 */

/**
 * Detects if the current device is a mobile device based on screen size and user agent
 * @returns {boolean} true if the device is considered mobile
 */
export const isMobileDevice = () => {
  // Check screen width (mobile devices typically have width <= 768px)
  const isMobileScreen = window.innerWidth <= 768;
  
  // Check user agent for mobile indicators
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    'android', 'iphone', 'ipad', 'ipod', 'blackberry', 
    'windows phone', 'mobile', 'webos', 'opera mini'
  ];
  const isMobileUserAgent = mobileKeywords.some(keyword => 
    userAgent.includes(keyword)
  );
  
  // Consider it mobile if either screen size or user agent indicates mobile
  return isMobileScreen || isMobileUserAgent;
};

/**
 * Detects if the current device is a tablet based on screen size
 * @returns {boolean} true if the device is considered a tablet
 */
export const isTabletDevice = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  
  // Tablets typically have width between 768px and 1024px
  // and aspect ratio closer to 4:3 or 16:10
  return width >= 768 && width <= 1024 && 
         (width / height) >= 0.75 && (width / height) <= 1.5;
};

/**
 * Gets the device type classification
 * @returns {string} 'mobile', 'tablet', or 'desktop'
 */
export const getDeviceType = () => {
  if (isMobileDevice()) {
    return 'mobile';
  } else if (isTabletDevice()) {
    return 'tablet';
  } else {
    return 'desktop';
  }
};

/**
 * Checks if the device should be treated as mobile for UI purposes
 * This includes both mobile phones and tablets
 * @returns {boolean} true if the device should use mobile UI
 */
export const shouldUseMobileUI = () => {
  return isMobileDevice() || isTabletDevice();
};